import React, { useMemo } from "react";
import { Card, CardContent } from "../ui/card";
import { fmtDateTime } from "../../lib/proposalPdf";
import { FileText, Mail, Activity } from "lucide-react";

// Aggregates emailLog entries across all of a client's proposals into a timeline.
export function ClientActivityLog({ proposals }) {
  const events = useMemo(() => {
    const all = [];
    (proposals || []).forEach((p) => {
      (p.emailLog || []).forEach((e) => {
        all.push({ ...e, eventTitle: p.eventTitle });
      });
    });
    return all.sort((a, b) => new Date(b.at) - new Date(a.at));
  }, [proposals]);

  return (
    <Card data-testid="activity-log">
      <CardContent className="p-6">
        <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider mb-4">
          Activity — sent emails ({events.length})
        </p>
        {events.length === 0 ? (
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Activity className="h-4 w-4" /> No emails sent yet.
          </div>
        ) : (
          <ol className="space-y-4">
            {events.map((e, i) => (
              <li key={`${e.at}-${e.type}-${e.to}-${i}`} data-testid={`activity-item-${i}`} className="flex items-start gap-3">
                <div className="h-8 w-8 rounded-full bg-accent flex items-center justify-center shrink-0">
                  {e.type === "proposal" ? (
                    <FileText className="h-4 w-4 text-primary" />
                  ) : (
                    <Mail className="h-4 w-4 text-primary" />
                  )}
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-medium text-foreground">
                    {e.type === "proposal" ? "Proposal sent" : "Custom email sent"}
                    {e.eventTitle ? ` · ${e.eventTitle}` : ""}
                  </p>
                  <p className="text-xs text-muted-foreground truncate">{e.subject}</p>
                  <p className="text-xs text-muted-foreground mt-0.5">
                    {fmtDateTime(e.at)} · to {e.to} · by {e.by}
                  </p>
                </div>
              </li>
            ))}
          </ol>
        )}
      </CardContent>
    </Card>
  );
}
